module.exports = __webpack_public_path__ + "img/banner-31.d54fc4be.jpg";